import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import MapWithInfoBox from "./MapWithInfoBox";
import AutoComplete from "./AutoComplete";
import PostAutoComplete from "./PostAutoComplete";
import UseFullPageLoader from "../FullPageLoader/UseFullPageLoader";
import NearbyTruckersModal from "./NearbyTruckersModal";


const Home = (props) => {
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [min_range, setMinRangeval] = useState(null);
  const [max_range, setMaxRangeval] = useState(null);
  const [searchLocation, setSearchLocation] = useState(null);
  const [searchLocationInput, setSearchLocationInput] = useState(null);
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState([]);
  const [video, setVideo] = useState([]);
  const [inputDocument, setInputDocument] = useState([]);
  const [errorlist, setError] = useState([]);
  const [errorlistImage, setErrorListImage] = useState([]);
  const userType = localStorage.getItem("type");
  const [formErrors, setFormErrors] = useState({});
  const postFormRef = useRef(null);
  const authToken = localStorage.getItem("auth_token");

  const [nearbyModalShow, setNearbyModalShow] = useState(false);
  const [nearbyLoading, setNearbyLoading] = useState(false);
  const [nearbyContractors, setNearbyContractors] = useState([]);
  const [nearbyCenter, setNearbyCenter] = useState(null);


  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");

  // prefill flags/refs
  const [isPrefill, setIsPrefill] = useState(false);
  const prefillRef = useRef({ stateId: "", cityId: "" });

  // track actual user changes (so we reset only on real change)
  const prevCountryIdRef = useRef("");
  const prevStateIdRef = useRef("");

  // ✅ NEW: filter panel toggle
  const [showFilterPanel, setShowFilterPanel] = useState(false);

  const history = useHistory();
  document.title = "DirtMap - Home";

  const [loader, showLoader, hideLoader] = UseFullPageLoader();

  const [searchInput, setSearchInput] = useState({
    search_location: "",
    latitude: "",
    longitude: "",
    radius: "15",
    type: "all",
    min_range: "",
    max_range: "",
    error_list: [],
  });

  const [postSiteInput, setPostSiteInput] = useState({
    user_id: localStorage.getItem("user_id") ? localStorage.getItem("user_id") : 0,
    item_type: "",
    project_name: "",
    cuyds_of_dirt_min: "",
    cuyds_of_dirt_max: "",
    address: "",
    latitude: "20.20",
    longitude: "30.30",
    description: "",
    special_instruction: "",
    name: "",
    email: "",
    phone: "",
    company_name: "",
    country: "",
    state: "",
    city: "",
    status: "",
  });

  const handleInput = (e) => {
    e.persist();
    setPostSiteInput({ ...postSiteInput, [e.target.name]: e.target.value });
  };

  const handleImage = (e) => {
    const files = Array.from(e.target.files);
    // if (files.length > 6) {
    //   alert("Max 6 images allowed");
    //   return;
    // }
    setImage(files);
  };

  const handleVideo = (e) => {
    const files = Array.from(e.target.files);
    // if (files.length > 6) {
    //   alert("Max 6 videos allowed");
    //   return;
    // }
    setVideo(files);
  };

  const handleDocument = (e) => {
    const files = Array.from(e.target.files);
    // if (files.length > 6) {
    //   alert("Max 6 documents allowed");
    //   return;
    // }
    setInputDocument(files);
  };

  const removeImage = (index) => {
    const updated = [...image];
    updated.splice(index, 1);
    setImage(updated);
  };

  const removeVideo = (index) => {
    const updated = [...video];
    updated.splice(index, 1);
    setVideo(updated);
  };

  const removeDocument = (index) => {
    const updated = [...inputDocument];
    updated.splice(index, 1);
    setInputDocument(updated);
  };

  const submitPostSite = async (e) => {
  e.preventDefault();

  if (!authToken) {
    await swal({
      title: "Error!",
      text: "You must first login for this action",
      icon: "error",
      button: "OK",
    });

    history.push("/login");
    return;
  }

  try {
    showLoader();
    setError([]);
    setErrorListImage([]);

    const formData = new FormData();

    // Images
    image.forEach((file, index) => {
      formData.append(`image[${index}]`, file);
    });

    // Videos
    video.forEach((file, index) => {
      formData.append(`video[${index}]`, file);
    });

    // Documents
    inputDocument.forEach((file, index) => {
      formData.append(`document[${index}]`, file);
    });

    formData.append(
      "user_id",
      postSiteInput.user_id || ""
    );

    formData.append(
      "item_type",
      postSiteInput.item_type || ""
    );

    formData.append(
      "project_name",
      postSiteInput.project_name || ""
    );

    formData.append(
      "cuyds_of_dirt_min",
      postSiteInput.cuyds_of_dirt_min || ""
    );

    formData.append(
      "cuyds_of_dirt_max",
      postSiteInput.cuyds_of_dirt_max || ""
    );

    formData.append(
      "address",
      postSiteInput.address || ""
    );

    formData.append(
      "latitude",
      postSiteInput.latitude || ""
    );

    formData.append(
      "longitude",
      postSiteInput.longitude || ""
    );

    formData.append(
      "description",
      postSiteInput.description || ""
    );

    formData.append(
      "special_instruction",
      postSiteInput.special_instruction || ""
    );

    formData.append(
      "name",
      postSiteInput.name || ""
    );

    formData.append(
      "email",
      postSiteInput.email || ""
    );

    formData.append(
      "phone",
      postSiteInput.phone || ""
    );

    formData.append(
      "company_name",
      postSiteInput.company_name || ""
    );

    formData.append(
      "country",
      postSiteInput.country || ""
    );

    formData.append(
      "state",
      postSiteInput.state || ""
    );

    formData.append(
      "city",
      postSiteInput.city || ""
    );

    formData.append(
      "status",
      postSiteInput.status || 1
    );

    await axios.get("/sanctum/csrf-cookie");

    const response = await axios.post(
      "/api/create/post/site",
      formData,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    const responseData = response.data || {};
    const validationErrors =
      responseData.errors || {};

    /*
     * Handle validation response returned with HTTP 200.
     */
    if (
      Number(responseData.status_code) === 422 ||
      Number(responseData.status) === 422 ||
      Object.keys(validationErrors).length > 0
    ) {
      setError(validationErrors);

      if (validationErrors.image) {
        setErrorListImage(
          validationErrors.image
        );
      }

      const firstErrorKey =
        Object.keys(validationErrors)[0];

      const firstErrorMessage =
        firstErrorKey
          ? Array.isArray(
              validationErrors[firstErrorKey]
            )
            ? validationErrors[firstErrorKey][0]
            : validationErrors[firstErrorKey]
          : responseData.message ||
            "Validation error";

      await swal({
        title: "Validation Error",
        text: firstErrorMessage,
        icon: "error",
        button: "OK",
      });

      return;
    }

    if (responseData.success === true) {
      setError([]);
      setErrorListImage([]);

      const lat = postSiteInput.latitude;
      const lng = postSiteInput.longitude;

      setNearbyModalShow(true);

      fetchNearbyContractorsByLatLng(
        lat,
        lng,
        2000
      );

      const element =
        document.getElementById("demo");

      if (element) {
        element.classList.remove("show");
      }

      return;
    }

    await swal({
      title: "Error",
      text:
        responseData.message ||
        "Failed to create site post.",
      icon: "error",
      button: "OK",
    });
  } catch (error) {
    console.error(
      "Create post error:",
      error
    );

    console.error(
      "Create post response:",
      error?.response?.data
    );

    /*
     * Handle PHP/Laravel PostTooLargeException.
     */
    if (error?.response?.status === 413) {
      const allSelectedFiles = [
        ...image,
        ...video,
        ...inputDocument,
      ];

      const totalBytes =
        allSelectedFiles.reduce(
          (total, file) =>
            total + Number(file.size || 0),
          0
        );

      const totalSizeMB =
        totalBytes / (1024 * 1024);

      // await swal({
      //   title: "Files Too Large",
      //   text:
      //     `Selected files total size: ${totalSizeMB.toFixed(
      //       2
      //     )} MB\n\n` +
      //     "The total upload size exceeds the server limit. Please upload smaller files or fewer files.",
      //   icon: "error",
      //   button: "OK",
      // });

      await swal({
                title: "Files Too Large",
                text:
                  "The total upload size is too large. Please upload smaller files or fewer files.",
                icon: "error",
                button: "OK",
              });
      

      return;
    }

    const responseData =
      error?.response?.data || {};

    const validationErrors =
      responseData.errors || {};

    if (
      error?.response?.status === 422 ||
      Object.keys(validationErrors).length > 0
    ) {
      setError(validationErrors);

      if (validationErrors.image) {
        setErrorListImage(
          validationErrors.image
        );
      }

      const firstErrorKey =
        Object.keys(validationErrors)[0];

      const firstErrorMessage =
        firstErrorKey
          ? Array.isArray(
              validationErrors[firstErrorKey]
            )
            ? validationErrors[firstErrorKey][0]
            : validationErrors[firstErrorKey]
          : responseData.message ||
            "Validation error";

      await swal({
        title: "Validation Error",
        text: firstErrorMessage,
        icon: "error",
        button: "OK",
      });

      return;
    }

    if (typeof responseData === "string") {
      await swal({
        title: "Server Error",
        text: responseData,
        icon: "error",
        button: "OK",
      });

      return;
    }

    await swal({
      title: "Error",
      text:
        responseData.message ||
        error.message ||
        "Failed to create site post.",
      icon: "error",
      button: "OK",
    });
  } finally {
    hideLoader();
  }
};

  const handleSearchInput = (e) => {
    e.persist();
    setSearchInput({ ...searchInput, [e.target.name]: e.target.value });
  };

  const setCoodinationValue = (value, ll) => {
    searchInput.search_location = value;
    searchInput.latitude = ll.lat;
    searchInput.longitude = ll.lng;
    document.getElementById("__searchLocation").value = value;
    document.getElementById("__latitude").value = ll.lat;
    document.getElementById("__longitude").value = ll.lng;
  };

  const setPostCoodinationValue = (value, ll) => {
    postSiteInput.address = value;
    postSiteInput.latitude = ll.lat;
    postSiteInput.longitude = ll.lng;
    document.getElementById("__postSearchLocation").value = value;
    document.getElementById("__postLatitude").value = ll.lat;
    document.getElementById("__postLongitude").value = ll.lng;
  };

  useEffect(() => {
    const t = setTimeout(() => setIsDisplayed(true), 1200);
    return () => clearTimeout(t);
  }, []);

  // Load countries on page load
  useEffect(() => {
    axios
      .get("/api/countryStateCity/list")
      .then((res) => {
        if (res.data.success) {
          setCountries(res.data?.result?.items || []);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // ✅ get user data (prefill)
  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (!userId) return;

    axios
      .get(`/api/get/profile/${userId}`)
      .then((res) => {
        if (res.data?.success) {
          const u = res.data?.result || {};

          setIsPrefill(true);

          const countryId = u.country ? String(u.country) : "";
          const stateId = u.state ? String(u.state) : "";
          const cityId = u.city ? String(u.city) : "";

          prefillRef.current.stateId = stateId;
          prefillRef.current.cityId = cityId;

          setPostSiteInput((prev) => ({
            ...prev,
            user_id: u.id || userId,
            name: `${u.first_name || ""} ${u.last_name || ""}`.trim() || prev.name,
            email: u.email || prev.email,
            phone: u.phone || u.phone_number || prev.phone,
            company_name: u.company_name || prev.company_name,
            country: countryId,
            state: stateId,
            city: cityId,
          }));

          setSelectedCountryId(countryId);
          setSelectedStateId(stateId);
          setSelectedCityId(cityId);
        }
      })
      .catch(console.log);
  }, []);

  // ✅ When country changes → load states
  useEffect(() => {
    const prevCountry = prevCountryIdRef.current;
    const countryChanged = prevCountry !== "" && prevCountry !== selectedCountryId;
    prevCountryIdRef.current = selectedCountryId;

    if (!selectedCountryId) {
      setStates([]);
      setCities([]);
      setSelectedStateId("");
      setSelectedCityId("");
      setPostSiteInput((prev) => ({ ...prev, country: "", state: "", city: "" }));
      return;
    }

    axios
      .get(`/api/countryStateCity/list?country_id=${selectedCountryId}`)
      .then((res) => {
        const items = res.data?.result?.items || [];
        setStates(items);

        setPostSiteInput((prev) => ({ ...prev, country: selectedCountryId }));

        // ✅ reset ONLY if user really changed country (not prefill/flags)
        if (countryChanged && !isPrefill) {
          setCities([]);
          setSelectedStateId("");
          setSelectedCityId("");
          setPostSiteInput((prev) => ({ ...prev, state: "", city: "" }));
          return;
        }

        // ✅ apply saved state AFTER states list exists
        if (isPrefill) {
          const savedState = prefillRef.current.stateId;
          if (savedState && items.some((s) => String(s.id) === String(savedState))) {
            setSelectedStateId(String(savedState));
            setPostSiteInput((prev) => ({ ...prev, state: String(savedState) }));
          }
        }
      })
      .catch((err) => console.log(err));
  }, [selectedCountryId]); // ✅ IMPORTANT: no isPrefill dependency here

  // ✅ When state changes → load cities
  useEffect(() => {
    const prevState = prevStateIdRef.current;
    const stateChanged = prevState !== "" && prevState !== selectedStateId;
    prevStateIdRef.current = selectedStateId;

    if (!selectedStateId) {
      setCities([]);
      setSelectedCityId("");
      setPostSiteInput((prev) => ({ ...prev, state: "", city: "" }));
      return;
    }

    axios
      .get(`/api/countryStateCity/list?state_id=${selectedStateId}`)
      .then((res) => {
        const items = res.data?.result?.items || [];
        setCities(items);

        setPostSiteInput((prev) => ({ ...prev, state: selectedStateId }));

        // ✅ reset ONLY if user really changed state
        if (stateChanged && !isPrefill) {
          setSelectedCityId("");
          setPostSiteInput((prev) => ({ ...prev, city: "" }));
          return;
        }

        // ✅ apply saved city AFTER cities list exists
        if (isPrefill) {
          const savedCity = prefillRef.current.cityId;
          if (savedCity && items.some((c) => String(c.id) === String(savedCity))) {
            setSelectedCityId(String(savedCity));
            setPostSiteInput((prev) => ({ ...prev, city: String(savedCity) }));
          }
          // ✅ end prefill after first city load
          setIsPrefill(false);
        }
      })
      .catch((err) => console.log(err));
  }, [selectedStateId]); // ✅ IMPORTANT: no isPrefill dependency here

  const submitSearchLocation = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!searchInput.search_location) {
      errors.search_location =
        "Search location is required";
    }

    if (!searchInput.type) {
      errors.type = "Please select a type";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormErrors({});

    const data = {
      location: searchInput.search_location,
      latitude: searchInput.latitude,
      longitude: searchInput.longitude,

      /*
      * Backend currently expects "redius".
      */
      redius: searchInput.radius || "15",
      radius: searchInput.radius || "15",

      type: searchInput.type || "all",

      cuyds_of_dirt_min: min_range || "",
      cuyds_of_dirt_max: max_range || "",

      user_id:
        localStorage.getItem("user_id") || "",
    };

    try {
      showLoader();

      await axios.get("/sanctum/csrf-cookie");

      const response = await axios.post(
        "/api/search/item",
        data,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      const responseData = response.data || {};

      if (responseData.success === true) {
        const result = Array.isArray(
          responseData.result
        )
          ? responseData.result
          : [];

        /*
        * Markers.
        * Empty array removes old markers.
        */
        setSearchLocation(result);

        /*
        * Always set searched coordinates.
        * This centers the map even when result is empty.
        */
        setSearchLocationInput({
          ...data,
          search_location: data.location,
        });

        setShowFilterPanel(false);

        if (result.length === 0) {
          await swal({
            title: "No Results",
            text:
              responseData.message ||
              "No site posts found near this location.",
            icon: "info",
            button: "OK",
          });
        }

        return;
      }

      const validationErrors =
        responseData.errors || {};

      if (
        Number(responseData.status_code) === 422 ||
        Object.keys(validationErrors).length > 0
      ) {
        setFormErrors({
          search_location:
            validationErrors.latitude?.[0] ||
            validationErrors.longitude?.[0] ||
            validationErrors.location?.[0],
        });

        await swal({
          title: "Validation Error",
          text:
            responseData.message ||
            "Please select a valid location.",
          icon: "error",
          button: "OK",
        });

        return;
      }

      await swal({
        title: "Search Failed",
        text:
          responseData.message ||
          "Unable to search this location.",
        icon: "error",
        button: "OK",
      });
    } catch (error) {
      console.error(
        "Search location error:",
        error
      );

      await swal({
        title: "Search Failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to search this location.",
        icon: "error",
        button: "OK",
      });
    } finally {
      hideLoader();
    }
  };

  const renderedMapWithInfoBox = useMemo(() => {
    return (
      <MapWithInfoBox
        searchLocation={searchLocation ? searchLocation : ""}
        searchLocationInput={searchLocationInput ? searchLocationInput : ""}
      />
    );
  }, [searchLocation, searchLocationInput]);

  const openPostForm = () => {
    const el = document.getElementById("demo");
    el.classList.toggle("show");

    setTimeout(() => {
      postFormRef.current?.scrollIntoView({ behavior: "smooth" });
      postFormRef.current?.focus();
    }, 300);
  };

  const fetchNearbyContractorsByLatLng = async (lat, lng, miles = 15) => {
  try {
    setNearbyLoading(true);

    const res = await axios.post("/api/nearby/contractors/by-user", {
      lat: Number(lat),
      lng: Number(lng),
      miles: Number(miles),
      flag: 'for_post_site',
    }, {
      headers: { Accept: "application/json" },
    });

    if (res.data?.success) {
      const result = res.data?.result || {};
      setNearbyContractors(result.data || []);
      setNearbyCenter({
        miles: result.miles,
        center_lat: result.center_lat,
        center_lng: result.center_lng,
      });
    } else {
      setNearbyContractors([]);
      swal("Error", res.data?.message || "Failed to fetch nearby contractors", "error");
    }
  } catch (e) {
    console.log(e);
    setNearbyContractors([]);
    swal("Error", e?.response?.data?.message || "Failed to fetch nearby contractors", "error");
  } finally {
    setNearbyLoading(false);
  }
};

const getCurrentLocation = () => {

  if (!navigator.geolocation) {
    swal("Error", "Geolocation is not supported by your browser", "error");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {

      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      const geocoder = new window.google.maps.Geocoder();

      const latlng = {
        lat: lat,
        lng: lng
      };

      geocoder.geocode({ location: latlng }, (results, status) => {

        if (status === "OK") {

          if (results[0]) {

            const address = results[0].formatted_address;

            setPostSiteInput(prev => ({
              ...prev,
              latitude: lat,
              longitude: lng,
              address: address
            }));

          }

        } else {
          console.log("Geocoder failed due to: " + status);
        }

      });

    },
    (error) => {
      swal("Error", "Unable to retrieve your location", "error");
      return;
    }
  );
};


const closeNearbyModalAndRefresh = () => {
  setNearbyModalShow(false);
  window.location.reload(); // refresh page
};


  const toggleFilterPanel = () => setShowFilterPanel((prev) => !prev);

  return (
    <section className="homepageBlock contactForm" style={{ padding: 0 }}>
      <div className="container-fluid" style={{ padding: 0 }}>
        <div className="row" style={{ margin: 0 }}>
          <div
            className="col-12 p-0 map-section-with-icon"
            style={{ position: "relative", minHeight: "calc(100vh - 80px)" }}
          >
            <div style={{ width: "100%", height: "100%" }}>{renderedMapWithInfoBox}</div>

            <div
              style={{
                position: "absolute",
                top: -5,
                right: 73,
                display: "flex",
                gap: 10,
               // zIndex: 9999,
              }}
            >
              <button
                type="button"
                className="button customButton01 active"
                onClick={toggleFilterPanel}
              >
                {showFilterPanel ? "Close Search" : "Search"}
              </button>

              {(userType === "normal" || !userType) && (
                <button
                  type="button"
                  className="button customButton01 active"
                  onClick={() => {
                    if (!authToken) {
                      history.push("/login");
                      return;
                    }
                    openPostForm();
                  }}
                >
                  Post Site
                </button>
              )}
            </div>

            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "420px",
                maxWidth: "90vw",
                background: "#fff",
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                transform: showFilterPanel ? "translateX(0)" : "translateX(-110%)",
                transition: "transform 0.25s ease",
                zIndex: 9998,
                overflowY: "auto",
                padding: 20,
              }}
            >
              <form onSubmit={submitSearchLocation}>
                <h6 className="mb-2">Search our Site for Dirt Import, Export or Dump Sites</h6>

                <div className="input-group locationInput">
                  <input
                    type="hidden"
                    id="__searchLocation"
                    name="search_location"
                    onChange={handleSearchInput}
                    value={searchInput.search_location}
                  />
                  <input
                    type="hidden"
                    id="__latitude"
                    name="latitude"
                    onChange={handleSearchInput}
                    value={searchInput.latitude}
                  />
                  <input
                    type="hidden"
                    id="__longitude"
                    name="longitude"
                    onChange={handleSearchInput}
                    value={searchInput.longitude}
                  />

                  {isDisplayed && <AutoComplete setCoodinationValue={setCoodinationValue} />}
                  {formErrors.search_location && (
                    <small className="text-danger" style={{ width: "100%" }}>{formErrors.search_location}</small>
                  )}
                </div>

                <div className="input-group">
                  <select
                    name="radius"
                    className="form-control radius-select"
                    onChange={handleSearchInput}
                    value={searchInput.radius}
                  >
                    <option value="15">15 Miles</option>
                    <option value="30">30 Miles</option>
                    <option value="50">50 Miles</option>
                    <option value="100">100 Miles</option>
                    {/* <option value="150">150 Miles</option>
                    <option value="200">200 Miles</option> */}
                  </select>
                </div>

                <div className="input-group last">
                  <select
                    name="type"
                    className="form-control"
                    onChange={handleSearchInput}
                    value={searchInput.type}
                  >
                    <option value="">Type</option>
                    <option value="import">Import</option>
                    <option value="export">Export</option>
                    <option value="dump_site">Dump Site</option>
                    <option value="truks">Trucks</option>
                    <option value="all">All</option>
                  </select>
                  {formErrors.type && <small className="text-danger"  style={{ width: "100%" }}>{formErrors.type}</small>}
                </div>

                <div className="inputField">
                  <button type="submit" className="button customButton01 active submitButton">
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div id="demo" className="collapse" style={{ width: "100%" }}>
            <div className="shadowBox m-30">
              <form onSubmit={submitPostSite}>
                <input type="hidden" name="user_id" onChange={handleInput} value={postSiteInput.user_id} />
                <input type="hidden" id="__postSearchLocation" name="address" onChange={handleInput} value={postSiteInput.search_location} />
                <input type="hidden" id="__postLatitude" name="latitude" onChange={handleInput} value={postSiteInput.latitude} />
                <input type="hidden" id="__postLongitude" name="longitude" onChange={handleInput} value={postSiteInput.longitude} />

                <div className="postItemsForm lightPinkBg02">
                  <h2 className="mt-3 mb-3">Post Your Site</h2>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">Select Item Type</div>
                    <div className="inputField">
                      <select
                        name="item_type"
                        ref={postFormRef}
                        onChange={handleInput}
                        value={postSiteInput.item_type}
                        className="form-control"
                      >
                        <option value="">Type</option>
                        <option value="import">Soil Import</option>
                        <option value="export">Soil Export</option>
                        <option value="dump_site">Dump Site</option>
                      </select>
                      <span className="validate-error-message">{errorlist.item_type}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox"> Project Name</div>
                    <div className="inputField">
                      <input
                        type="text"
                        name="project_name"
                        onChange={handleInput}
                        value={postSiteInput.project_name}
                        className="form-control"
                        placeholder="Enter Project Name"
                      />
                      <span className="validate-error-message">{errorlist.project_name}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox"> CuYds of Dirt Min</div>
                    <div className="inputField">
                      <input
                        type="text"
                        name="cuyds_of_dirt_min"
                        onChange={handleInput}
                        value={postSiteInput.cuyds_of_dirt_min}
                        className="form-control"
                        placeholder="Enter CuYds Of Dirt"
                      />
                      <span className="validate-error-message">{errorlist.cuyds_of_dirt_min}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox"> CuYds of Dirt Max</div>
                    <div className="inputField">
                      <input
                        type="text"
                        name="cuyds_of_dirt_max"
                        onChange={handleInput}
                        value={postSiteInput.cuyds_of_dirt_max}
                        className="form-control"
                        placeholder="Enter CuYds Of Dirt"
                      />
                      <span className="validate-error-message">{errorlist.cuyds_of_dirt_max}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox"> Add Location </div>
                    <div className="inputField postSite">
                      {isDisplayed && <PostAutoComplete 
                      setPostCoodinationValue={setPostCoodinationValue} 
                      address={postSiteInput.address}
                      />}
                      <button
                        type="button"
                        className="btn btn-sm btn-primary mt-2"
                        onClick={getCurrentLocation}
                      >
                        Use Current Location
                      </button>
                      <span className="validate-error-message">{errorlist.address}</span>
                    </div>
                    <div className="fieldsetInfoText"> Add location on google map or use your current location </div>
                  </div>

                  <div className="customFormRow message customFormRow02">
                    <div className="labelBox"> Description</div>
                    <div className="inputField">
                      <textarea
                        name="description"
                        onChange={handleInput}
                        value={postSiteInput.description}
                        className="form-control"
                        placeholder="Enter Description"
                      />
                      <span className="validate-error-message">{errorlist.description}</span>
                    </div>
                  </div>
                </div>

                <div className="postItemsForm lightPinkBg02">
                  <h6 className="mb-2">Upload Images, Videos, Document etc</h6>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">Images</div>
                    <div className="inputField">
                      <label>
                        <input type="file" name="image" onChange={handleImage} multiple accept="image/*" className="form-control" />
                        <span className="validate-error-message">{errorlist.image}</span>
                        <div className="preview-container">
                          {image.map((file, index) => (
                            <div key={index} className="preview-box">
                              <img src={URL.createObjectURL(file)} alt="" width="100" />
                              <button type="button" onClick={() => removeImage(index)}>❌</button>
                            </div>
                          ))}
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox"> Video</div>
                    <div className="inputField">
                      <label>
                        <input 
                          type="file" 
                          name="video" 
                          onChange={handleVideo} 
                          multiple 
                          accept="video/mp4,video/quicktime,video/ogg"
                          className="form-control" 
                        />

                        <span className="validate-error-message">{errorlist.video}</span>

                        <div className="preview-container">
                          {video.map((file, index) => (
                            <div key={index} className="preview-box">
                              <video width="120" controls>
                                <source src={URL.createObjectURL(file)} type={file.type} />
                              </video>
                              <button type="button" onClick={() => removeVideo(index)}>❌</button>
                            </div>
                          ))}
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox"> Document</div>
                    <div className="inputField">
                      <label>
                        <input type="file" name="document" onChange={handleDocument} multiple className="form-control" />
                        <span className="validate-error-message">{errorlist.document}</span>

                        <div className="preview-container">
                          {inputDocument.map((file, index) => (
                            <div key={index} className="preview-box">
                              <p>{file.name}</p>
                              <button type="button" onClick={() => removeDocument(index)}>❌</button>
                            </div>
                          ))}
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="customFormRow message customFormRow02">
                    <div className="labelBox"> Special Instructions</div>
                    <div className="inputField">
                      <textarea
                        type="text"
                        name="special_instruction"
                        onChange={handleInput}
                        value={postSiteInput.special_instruction}
                        className="form-control"
                        placeholder="Enter Special Instruction"
                      />
                      <span className="validate-error-message">{errorlist.special_instruction}</span>
                    </div>
                  </div>
                </div>

                <div className="postItemsForm lightPinkBg02">
                  <h6 className="mb-2">Contact Info</h6>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">Name</div>
                    <div className="inputField">
                      <input type="text" name="name" onChange={handleInput} value={postSiteInput.name} className="form-control" placeholder="Enter Name" />
                      <span className="validate-error-message">{errorlist.name}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">Email</div>
                    <div className="inputField">
                      <input type="text" name="email" onChange={handleInput} value={postSiteInput.email} className="form-control" placeholder="Enter Email" />
                      <span className="validate-error-message">{errorlist.email}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">Phone Number</div>
                    <div className="inputField">
                      <input type="text" name="phone" onChange={handleInput} value={postSiteInput.phone} className="form-control" placeholder="Enter Phone Number" />
                      <span className="validate-error-message">{errorlist.phone}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">Company Name</div>
                    <div className="inputField">
                      <input type="text" name="company_name" onChange={handleInput} value={postSiteInput.company_name} className="form-control" placeholder="Enter Company Name" />
                      <span className="validate-error-message">{errorlist.company_name}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">Country</div>
                    <div className="inputField">
                      <select
                        className="form-control"
                        value={selectedCountryId}
                        onChange={(e) => {
                          const id = e.target.value;
                          setSelectedCountryId(id);
                          setPostSiteInput((prev) => ({ ...prev, country: id }));
                        }}
                      >
                        <option value="">Select Country</option>
                        {countries.map((c) => (
                          <option key={c.id} value={String(c.id)}>
                            {c.name}
                          </option>
                        ))}
                      </select>
                      <span className="validate-error-message">{errorlist.country}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">State</div>
                    <div className="inputField">
                      <select
                        className="form-control"
                        value={selectedStateId}
                        disabled={!selectedCountryId}
                        onChange={(e) => {
                          const id = e.target.value;
                          setSelectedStateId(id);
                          setPostSiteInput((prev) => ({ ...prev, state: id }));
                        }}
                      >
                        <option value="">Select State</option>
                        {states.map((s) => (
                          <option key={s.id} value={String(s.id)}>
                            {s.name}
                          </option>
                        ))}
                      </select>
                      <span className="validate-error-message">{errorlist.state}</span>
                    </div>
                  </div>

                  <div className="customFormRow customFormRow02">
                    <div className="labelBox">City</div>
                    <div className="inputField">
                      <select
                        className="form-control"
                        value={selectedCityId}
                        disabled={!selectedStateId}
                        onChange={(e) => {
                          const id = e.target.value;
                          setSelectedCityId(id);
                          setPostSiteInput((prev) => ({ ...prev, city: id }));
                        }}
                      >
                        <option value="">Select City</option>
                        {cities.map((ci) => (
                          <option key={ci.id} value={String(ci.id)}>
                            {ci.name}
                          </option>
                        ))}
                      </select>
                      <span className="validate-error-message">{errorlist.city}</span>
                    </div>
                  </div>

                  <div className="col-md-1 form-check mb-3 ml-2" style={{ display: "none" }}>
                    <input
                      name="status"
                      onChange={handleInput}
                      className="form-check-input"
                      id="inputRememberPassword"
                      type="checkbox"
                      value="1"
                      checked
                      readOnly
                    />
                    <label className="form-check-label">Status</label>
                    <span className="validate-error-message">{errorlist.status}</span>
                  </div>
                </div>

                <div className="postItemsForm">
                  <div className="customFormRow last">
                    <div className="inputField">
                      <input type="submit" className="button customButton01 post-submit active submitButton" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {loader}

      <NearbyTruckersModal
        show={nearbyModalShow}
        onClose={closeNearbyModalAndRefresh}
        loading={nearbyLoading}
        contractors={nearbyContractors}
        center={nearbyCenter}
      />

    </section>
  );
};

export default Home;
